import { Stack, Typography } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StagingBanner from "StagingBanner";
import { AWSCognitoProvider as AuthProvider } from "contexts/AWSCognitoContext";
import "dayjs/locale/en";
import "dayjs/locale/es";
import "dayjs/locale/fr";
import "dayjs/locale/pt";
import useConfig from "hooks/useConfig";
import NavigationScroll from "layout/NavigationScroll";
import { useEffect } from "react";
import { CookiesProvider } from "react-cookie";
import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router-dom";
import Routes from "routes";
import ThemeCustomization from "themes";
import Locales from "ui-component/Locales";
import Logo from "ui-component/Logo";
import Snackbar from "ui-component/extended/Snackbar";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);
const App = () => {
  const { locale } = useConfig();
  const location = useLocation();

  useEffect(() => {
    window.gtag("event", "page_view", {
      page_title: location.pathname,
      page_path: location.pathname + location.search + location.hash,
      page_search: location.search,
      page_hash: location.hash,
    });
  }, [location]);

  const isInIframe = window !== window.top;

  if (isInIframe) {
    return (
      <ThemeCustomization>
        <Locales>
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={locale}
          >
            {/* Display in the center of the page verticaly and horizontaly */}
            <Stack
              direction="column"
              justifyContent="center"
              alignItems="center"
              spacing={4}
              sx={{ width: 1, height: "100vh", p: 10 }}
            >
              <Logo />
              <Typography variant="h3" gutterBottom>
                <FormattedMessage id="general.widget_iframe" />
              </Typography>
              <Typography variant="body1">
                <FormattedMessage id="general.widget_access" />
              </Typography>
              <a href={window.location.href} target="_blank" rel="noreferrer">
                {window.location.href}
              </a>
            </Stack>
          </LocalizationProvider>
        </Locales>
      </ThemeCustomization>
    );
  }

  const isNotProd = process.env.REACT_APP_ENVIRONMENT !== "production";
  return (
    <ThemeCustomization>
      <Locales>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
          <NavigationScroll>
            <AuthProvider>
              <CookiesProvider>
                <Elements options={{ locale: locale }} stripe={stripePromise}>
                  <>
                    {isNotProd && <StagingBanner />}
                    <Routes />
                    <Snackbar />
                  </>
                </Elements>
              </CookiesProvider>
            </AuthProvider>
          </NavigationScroll>
        </LocalizationProvider>
      </Locales>
    </ThemeCustomization>
  );
};
export default App;
